import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AutosizeModule } from '../../shared/autosize-module';

import { AddSpecialInstructionsPage } from './add-special-instructions.page';

const routes: Routes = [
  {
    path: '',
    component: AddSpecialInstructionsPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AutosizeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AddSpecialInstructionsPage]
})
export class AddSpecialInstructionsPageModule {}
